import Helper from './Helper';

class Toggler {
  constructor(config = {}) {
    const {
      togglerButtonSelector,
      togglerContainerSelector
    } = config;

    this.togglers = document.querySelectorAll(togglerButtonSelector);
    this.togglerArray = Array.prototype.slice.call(this.togglers);
    this.togglerContainerSelector = togglerContainerSelector;
    if(this.togglers){
      this.bindEvents();
    }
  }

  bindEvents() {
    this.togglerArray.forEach(toggler => {
      toggler.addEventListener('click', e  => {
        const parent = toggler.parentElement.parentElement;
        // console.log(parent);
        const container = parent.querySelector(this.togglerContainerSelector);
        // console.log(container);
        Helper.slideToggle(container);
      });
    });
  }

}

export default Toggler;
